import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
    selector: 'formly-primeng-field-multiselect',
    imports: [ReactiveFormsModule, MultiSelectModule],
    template: `
        <p-multiselect
            class="w-full"
            appendTo="body"
            [options]="selectOptions"
            [id]="fieldId"
            [formControl]="formControl"
            optionLabel="label"
            optionValue="value"
            [group]="props.group?props.group:false"
        >
        </p-multiselect>
    `,
})

export class MultiSelectFieldCosmos extends FieldType<FieldTypeConfig> {

    get selectOptions(): any[] {
        return Array.isArray(this.props.options) ? this.props.options : [];
    }

    get fieldId(): string {
        return Array.isArray(this.key) ? this.key.join('_') : String(this.key);
    }

    ngOnInit() { }
}